import { Flex } from 'foundations-components/components/Flex';
import { View } from 'foundations-components/components/View';
import { List } from 'foundations-components/transitional/components/List';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function ReviewActionsWrapper({
  children,
  itemRight
}) {
  return /*#__PURE__*/_jsxs(Flex, {
    flexDirection: "row",
    justifyContent: "space-between",
    children: [/*#__PURE__*/_jsx(List, {
      inline: true,
      use: "inline-divided",
      marginBlockStart: "600",
      children: children
    }), /*#__PURE__*/_jsx(View, {
      marginBlockStart: "600",
      as: "span",
      children: itemRight
    })]
  });
}